// Моковые данные для таблицы "Новый учебный год"

export const mockTableData = [
  {
    id: 1,
    oldName: '5-е классы',
    oldParallel: 5,
    newName: '6-е классы',
    newParallel: 6,
    isGroup: true,
    show: false,
    children: [
      {
        id: 11,
        oldName: '5Б',
        oldParallel: 5,
        newName: '7Б',
        newParallel: 6,
        periodType: 'Четверть',
        isGraduation: false,
        date: '25.02.2026',
        orderNumber: '',
        orderDate: '',
        protocolNumber: '',
        protocolDate: ''
      }
    ]
  },
  {
    id: 2,
    oldName: '7-е классы',
    oldParallel: 7,
    newName: '8-е классы',
    newParallel: 8,
    isGroup: true,
    show: false,
    children: [
      {
        id: 21,
        oldName: '7А',
        oldParallel: 7,
        newName: '9А',
        newParallel: 8,
        periodType: 'Четверть',
        isGraduation: false,
        date: '25.02.2026',
        orderNumber: '',
        orderDate: '',
        protocolNumber: '',
        protocolDate: ''
      }
    ]
  },
  {
    id: 3,
    oldName: '9-е классы',
    oldParallel: 9,
    newName: '10-е классы',
    newParallel: 10,
    isGroup: true,
    show: false,
    children: [
      {
        id: 31,
        oldName: '9А',
        oldParallel: 9,
        newName: '10А',
        newParallel: 10,
        periodType: 'Полугодие',
        isGraduation: true,
        date: '25.02.2026',
        orderNumber: '45-п',
        orderDate: '01.06.2026',
        protocolNumber: '12',
        protocolDate: '28.05.2026'
      },
      {
        id: 32,
        oldName: '9Б',
        oldParallel: 9,
        newName: '10Б',
        newParallel: 10,
        periodType: 'Полугодие',
        isGraduation: true,
        date: '25.02.2026',
        orderNumber: '45-п',
        orderDate: '01.06.2026',
        protocolNumber: '12',
        protocolDate: '28.05.2026'
      }
    ]
  },
  {
    id: 4,
    oldName: '11-е классы',
    oldParallel: 11,
    newName: 'Выпуск',
    newParallel: null,
    isGroup: true,
    show: false,
    children: [
      {
        id: 41,
        oldName: '11А',
        oldParallel: 11,
        newName: 'Выпуск',
        newParallel: null,
        periodType: 'Полугодие',
        isGraduation: true,
        date: '25.06.2026',
        orderNumber: '78-в',
        orderDate: '20.06.2026',
        protocolNumber: '15',
        protocolDate: '18.06.2026'
      }
    ]
  }
]

// Начальные значения формы для Formik
export const initialFormValues = {
  schoolYearId: '',
  renameClasses: false,
  copySchedule: false,
  updateElectives: false,
  addTransferStatus: false,
  addGraduationStatus: false,
  formSubjectGroups: false,
  orderDate: '',
  orderNumber: '',
  protocolDate: '',
  protocolNumber: ''
}

// Типы периодов
export const periodTypes = [
  { value: 'quarter', label: 'Четверть' },
  { value: 'semester', label: 'Полугодие' },
  { value: 'trimester', label: 'Триместр' }
]
